/* eslint-disable no-undef */
$(document).ready(function () {
  /* faq question button handling */
  $('.question').on('click', function () {
    $(this).next().slideToggle()
    if ($(this).find('.plus').hasClass('rotated')) $(this).find('.plus').removeClass('rotated')
    else $(this).find('.plus').addClass('rotated')
  })

  /* process button handling */
  $('.show_process').on('click', function () {
    if ($(this).hasClass('showing')) {
      $(this).removeClass('showing')
    } else {
      $(this).addClass('showing')
    }
    $(this).siblings('.process-tasks').slideToggle()
  })

  /* tag filtering on references page */
  $('.tag-filtering .button').on('click', function () {
    if (!$(this).hasClass('active')) {
      $(this).siblings('.active').removeClass('active')
      $(this).addClass('active')
      filterTags($(this).data('filter'))
    }
  })
  /* handling redirections for forms after submit */
  $(document).on('wpcf7mailsent', function (event) {
    /* localhost form id			CONTACT FORM		    server form id */
    if (event.detail.contactFormId === 735 || event.detail.contactFormId === 401) {
      location = myVariables.contact_thanks

      /* localhost form id	 PETTERNET CREDENTIALS ORDER FORM	   server form id */
    } else if (event.detail.contactFormId === 736 || event.detail.contactFormId === 277) {
      location = myVariables.petternet_thanks
    }
  })
})

function filterTags (filter) {
  if (filter) {
    $('.news-grid .wp-block-column').each(function () {
      const categories = $(this).data('filter').split(',')
      if ($.inArray(filter, categories) >= 0) {
        $(this).css('display', 'flex')
      } else {
        $(this).css('display', 'none')
      }
    })
  } else {
    $('.news-grid .wp-block-column').css('display', 'flex')
  }
}
